import { render } from "./OptionInput.vue?vue&type=template&id=5339bf9d"
import script from "./OptionInput.vue?vue&type=script&lang=js"
export * from "./OptionInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__